import '../assets/NcMentionBubble-7PQ8wEko.css';
import '../assets/NcListItemIcon-9Dazpmpd.css';
import { N as i, u as r } from "./NcAvatar-BBhoG-za.mjs";
import { N as n } from "./index-CnpswYi6.mjs";
import { N as o } from "./NcIconSvgWrapper-BTdzvQGV.mjs";
import "../Composables/useIsFullscreen.mjs";
import "../Composables/useIsMobile.mjs";
import "@nextcloud/router";
/* empty css                                                                          */
import { n as c } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
import "linkify-string";
import "escape-html";
import "striptags";
import "vue";
const l = 8, e = 32, u = {
  name: "NcListItemIcon",
  components: {
    NcAvatar: i,
    NcHighlight: n,
    NcIconSvgWrapper: o
  },
  mixins: [
    r
  ],
  props: {
    /**
     * Default first line text
     */
    name: {
      type: String,
      required: !0
    },
    /**
     * Secondary optional line
     * Only visible on size of 32 and above
     */
    subname: {
      type: String,
      default: ""
    },
    /**
     * Icon class to be displayed at the end of the component
     */
    icon: {
      type: String,
      default: ""
    },
    /**
     * SVG icon to be displayed at the end of the component
     */
    iconSvg: {
      type: String,
      default: ""
    },
    /**
     * Descriptive name for the icon
     */
    iconName: {
      type: String,
      default: ""
    },
    /**
     * Search within the highlight of name/subname
     */
    search: {
      type: String,
      default: ""
    },
    /**
     * Set a size in px that will define the avatar height/width
     * and therefore, the height of the component
     */
    avatarSize: {
      type: Number,
      default: e
    },
    /**
     * Disable the margins of this component.
     * Useful for integration in `NcSelect` for example
     */
    noMargin: {
      type: Boolean,
      default: !1
    },
    /**
     * See the [Avatar](#Avatar) displayName prop
     * Fallback to name
     */
    displayName: {
      type: String,
      default: null
    },
    /**
     * See the [Avatar](#Avatar) isNoUser prop
     * Enable/disable the UserStatus fetching
     */
    isNoUser: {
      type: Boolean,
      default: !1
    },
    /**
     * Unique list item ID
     */
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      margin: l
    };
  },
  computed: {
    hasIcon() {
      return this.icon !== "";
    },
    hasIconSvg() {
      return this.iconSvg !== "";
    },
    isValidSubname() {
      var a, t;
      return ((t = (a = this.subname) == null ? void 0 : a.trim) == null ? void 0 : t.call(a)) !== "";
    },
    isSizeBigEnough() {
      return this.avatarSize >= e;
    },
    cssVars() {
      const a = this.noMargin ? 0 : this.margin;
      return {
        "--height": this.avatarSize + 2 * a + "px",
        "--margin": this.margin + "px"
      };
    },
    /**
     * Seperates the search property into two parts, the first one is the search part on the name, the second on the subname.
     * @return {[string, string]}
     */
    searchParts() {
      const a = /^([^<]*)<([^>]+)>?$/, t = this.search.match(a);
      return this.isNoUser || !t ? [this.search, this.search] : [t[1].trim(), t[2]];
    }
  },
  beforeMount() {
    !this.isNoUser && !this.subname && this.fetchUserStatus(this.user);
  }
};
var m = function() {
  var t = this, s = t._self._c;
  return s("span", t._g({ staticClass: "option", style: t.cssVars, attrs: { id: t.id } }, t.$listeners), [s("NcAvatar", t._b({ staticClass: "option__avatar", attrs: { "disable-menu": !0, "disable-tooltip": !0, "display-name": t.displayName || t.name, "is-no-user": t.isNoUser, size: t.avatarSize } }, "NcAvatar", t.$attrs, !1)), s("div", { staticClass: "option__details" }, [s("NcHighlight", { staticClass: "option__lineone", attrs: { text: t.name, search: t.searchParts[0] } }), t.isValidSubname && t.isSizeBigEnough ? s("NcHighlight", { staticClass: "option__linetwo", attrs: { text: t.subname, search: t.searchParts[1] } }) : t.hasStatus ? s("span", [s("span", [t._v(t._s(t.userStatus.icon))]), s("span", [t._v(t._s(t.userStatus.message))])]) : t._e()], 1), t._t("default", function() {
    return [t.hasIconSvg ? s("NcIconSvgWrapper", { staticClass: "option__icon", attrs: { svg: t.iconSvg, name: t.iconName } }) : t.hasIcon ? s("span", { staticClass: "icon option__icon", class: t.icon, attrs: { "aria-label": t.iconName } }) : t._e()];
  })], 2);
}, p = [], h = /* @__PURE__ */ c(
  u,
  m,
  p,
  !1,
  null,
  "562c32c6",
  null,
  null
);
const x = h.exports;
export {
  x as N
};
